import queryString from "query-string";

const parseQuery = (options) => (query) => queryString.parse(query, options);
const stringifyQuery = (options) => (query) =>
  queryString.stringify(query, options);

export const parseWithIndexFormat = parseQuery({ arrayFormat: "index" });

export const stringifyWithIndexFromat = stringifyQuery({
  arrayFormat: "index",
});
export const stringifyWithoutIndexFromat = stringifyQuery({});
export const parseWithoutIndexFormat = parseQuery({});
